export default "__VITE_ASSET__DMdvIjNX__"